export const SET_SURGERY_TYPE = "set_surgery_type";
export const GET_SURGERY_HISTORY_DATA = "get_surgery_history_data";
export const REQ_SURGERY_HISTORY_DATA = "req_surgery_history_data";
export const ADD_SURGERY_HISTORY_DATA = "add_surgery_history_data";
export const SET_SURGERY_HISTORY_DATA = "set_surgery_history_data";
export const DELETE_SURGERY_HISTORY_DATA = "delete_surgery_history_data";
export const GET_SURGERY_PARTS = "get_surgery_parts";
export const REQ_SURGERY_PARTS = "req_surgery_parts";
